import { VariantProps } from 'class-variance-authority';
import { ComponentType } from 'react';

import { mergeClasses } from '@/utils';

import { CheckIcon } from '@/assets/icons';
import { SvgIcon } from '@/components/common';

import { COUNTER_VARIANTS } from './Counter.constants';

export interface ICounter
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof COUNTER_VARIANTS> {
  label?: string;
  value: string | React.ReactNode;
  icon?: ComponentType<{ className?: string }>;
  iconClassName?: string;
  iconLabel?: string;
  disabled?: boolean;
}

const Counter = ({
  className,
  variant,
  label,
  value,
  icon,
  iconClassName,
  iconLabel,
  ...props
}: ICounter) => {
  return (
    <div className={mergeClasses(COUNTER_VARIANTS({ variant }), className)} {...props}>
      <div
        data-slot="title"
        className={mergeClasses('flex', variant === 'horizontal' ? 'gap-4' : 'gap-2')}
      >
        <span
          data-slot="icon"
          className={mergeClasses(
            'bg-neutral-3 dark:bg-neutral-8 border border-neutral-4 dark:border-neutral-7 flex items-center justify-center w-auto gap-2 text-neutral-9 dark:text-neutral-0',
            variant === 'horizontal' ? 'h-10 min-w-10' : 'h-8 min-w-8',
            iconLabel && 'px-3 !rounded-lg',
            iconClassName,
          )}
        >
          <SvgIcon
            component={icon ?? CheckIcon}
            className={mergeClasses(
              'size-4 text-inherit',
              variant === 'horizontal' ? 'size-5' : 'size-4',
            )}
          />
          {iconLabel && (
            <div data-slot="icon-label" className="font-semibold text-body-sm">
              {iconLabel}
            </div>
          )}
        </span>

        {label && (
          <div
            data-slot="label"
            className="text-neutral-9 dark:!text-neutral-0 font-medium text-body-sm"
          >
            {label}
          </div>
        )}
      </div>
      <div data-slot="value" className="font-bold text-h1 text-neutral-10 dark:!text-neutral-0">
        {value}
      </div>
    </div>
  );
};

export { Counter };
